import MainLayout from "@/components/layout/mainLayout";
import Portfolio from "./portfolio";

const PortFolioLayout = () => {
    return (
        <MainLayout>
            <Portfolio />
        </MainLayout>
    );
}

export default PortFolioLayout;